export default __webpack_public_path__ + "static/media/morten-1.1-glad-for-livet-som-slagterelev-fastbr-subs.1791ee57.mp4";